import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SecurityRoleService } from '@app/modules/security-roles/services/security-role.service';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';
import { GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-select-security-role-dialog',
  templateUrl: './select-security-role-dialog.component.html',
  styleUrls: ['./select-security-role-dialog.component.scss']
})
export class SelectSecurityRoleDialogComponent implements OnInit {
  @Output() emitSelectedSecurityRoles: EventEmitter<string[]> = new EventEmitter<string[]>();

  public gridDataResult: GridDataResult;
  public selectedItems: any[] = [];
  public columns: any[] = [
    { field: 'name', title: 'Name', dataType: "String" },
    { field: 'totalUsers', title: 'Total Users', dataType: "String" },
    { field: 'roleType', subField: 'name', title: 'Role Type', dataType: "String" },
    { field: 'description', title: 'Description', type: "longText", dataType: "String" },
  ]

  public filterCategories: any[] = [
    { field: 'name', title: 'Name', dataType: "String" },
    { field: 'description', title: 'Description', dataType: "String" }
  ];

  sortableColumns: any[] = [
    { field: "name", sortValue: "name" },
    { field: "totalUsers", sortValue: "totalUsers" },
    { field: "roleType", sortValue: "roleType.name" },
    { field: "description", sortValue: "description" }
  ];

  public sort: SortDescriptor[] = [];
  filterString: string;
  filterToggleDetails: {
    text: string,
    checked: boolean
  } = {
      text: 'FilterInactive',
      checked: true
    }
  isLoading: boolean;
  pageSize: number = 20;
  skip: number = 0;
  sortString: string;
  getSecurityRolesRequest: any;
  clearSelectedItems: boolean = false;
  selectedSecurityRoles: any[] = [];

  public searchFilterString: string;
  public searchValue: string;
  getRequest: any;
  error: boolean;
  selectionSettings: { canSelectRows: boolean; selectableMode: any; selectRowBy: string; };

  constructor(
    private dialogRef: MatDialogRef<SelectSecurityRoleDialogComponent>,
    private securityRoleService: SecurityRoleService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.selectedSecurityRoles = data.nonSelectableItems || [];
    this.selectionSettings = {
      canSelectRows: true,
      selectableMode: data.selectableMode || 'single',
      selectRowBy: 'id'
    };
  }

  ngOnInit(): void {
    this.getSecurityRoles();
  }

  get selectedSecurityRolesIds(): string[] {
    return this.selectedSecurityRoles.map(role => role.id);
  }

  getSecurityRoles(): void {
    this.isLoading = true;

    this.getRequest = this.securityRoleService.getSecurityRoles(this.pageSize, this.skip, this.searchFilterString, this.sortString)
      .subscribe(
        {
          next: (v) => {
            this.gridDataResult = {
              data: v.data,
              total: v.total,
            };
          },
          error: (e) => {
            this.error = true;
            this.isLoading = false;
          },
          complete: () => this.isLoading = false
        }
      );
  }

  gridStateChange(gridState: GridState) {
    if (this.pageSize !== gridState.pageSize) {
      this.pageSize = gridState.pageSize;
    }
    if (this.skip !== gridState.skip) {
      this.skip = gridState.skip;
    }
    if (this.sortString !== gridState.sortString) {
      this.sortString = gridState.sortString;
    }
    if (this.filterString !== gridState.filter) {
      this.filterString = gridState.filter;
      this.skip = 0;
    }

    if (gridState.filterToggleDetails === null) {
      this.filterToggleDetails.checked = false;
      this.skip = 0;
    } else if (this.filterToggleDetails.checked !== gridState.filterToggleDetails.checked) {
      this.filterToggleDetails.checked = gridState.filterToggleDetails.checked;
      this.skip = 0;
    }

    if (this.searchValue !== gridState.searchValue) {
      let variants = [];
      this.searchFilterString = '';
      this.searchValue = gridState.searchValue;

      if (this.searchValue !== null) {
        variants = this.searchValue.split(' ').filter(value => value);
      }

      variants.map(variant => {
        if (variant) {
          if (this.searchFilterString.length > 2) {
            this.searchFilterString += ' OR ';
          }
          this.searchFilterString += `(Name like "${variant}")`;
        }
      });

      this.skip = 0;
    }

    this.getRequest.unsubscribe();
    this.getSecurityRoles();
  }

  selectedRowsChanged(selectionEvent: SelectionEvent) {
    selectionEvent.selectedRows.forEach(row => {
      this.selectedSecurityRoles.push(row.dataItem)
    });

    selectionEvent.deselectedRows.forEach(row => {
      this.selectedSecurityRoles = this.selectedSecurityRoles.filter(item => item.id !== row.dataItem.id)
    });
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.emitSelectedSecurityRoles.emit(this.selectedSecurityRoles);
    this.dialogRef.close();
  }

}
